import Alert from '@mui/material/Alert';

export function ForgotPassordRequestSuccessPage() {
  return (
    <div
      style={{
        color: '#888',
        margin: 0,
      }}
    >
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Alert
          severity="success"
          style={{
            fontSize: '2rem',
            margin: 0,
          }}
        >
          パスワード再設定用のリンクを送信しました
        </Alert>
      </div>
    </div>
  );
}
